import React from 'react'
import { View } from 'styles/reactnative'
import { PopUpTitleSection } from '../../styles'
import SettingTitle from '../../SettingTitle'

const PopUpModalHeader = ({ title, content }) => {
	return (
		<View style={{ flexDirection: 'row', width: '100%' }}>
			<PopUpTitleSection
				style={{
					borderBottomColor: 'transparent',
					borderRight: 0,
					borderBottom: 0,
				}}>
				<SettingTitle title={title} />
			</PopUpTitleSection>
			<PopUpTitleSection
				style={{
					borderBottomColor: 'transparent',
					borderBottom: 0,
					width: '100%',
				}}>
				<SettingTitle title={content} />
			</PopUpTitleSection>
		</View>
	)
}

export default PopUpModalHeader
